import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { MdrCompaniesGridDataProviderFactory } from '../factory/MdrCompaniesGridDataProviderFactory';
import { MdrCompaniesGridWebComponentSchema } from '../types';
import { MdrCompaniesGridDataProvider } from '../dataProvider/MdrCompaniesGridDataProvider';

export class MdrCompaniesGridRepository extends BaseWebComponentRepository {
  public dataProviderFactory: MdrCompaniesGridDataProviderFactory;
  public dataProvider: MdrCompaniesGridDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new MdrCompaniesGridDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<MdrCompaniesGridWebComponentSchema> {
    return this.dataProvider.getDataForView();
  }
}
